<template>
  <div class="my_radio_group">
    <el-radio-group v-model="radioVal" @change="clickRadio">
      <el-radio :label="item.status" v-for="(item, index) in list"
        >{{ item.name }}
        <span v-if="is_show">({{ countArr[index] }})</span>
      </el-radio>
    </el-radio-group>
  </div>
</template>

<script>
import { PointerNumber } from "@/api/student";
export default {
  props: {
    // 子组件使用value接收父组件的传参
    // value: {
    //   type: Number,
    // },
    list: {
      type: Array,
    },
    is_show: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      radioVal: 0,
      countArr: [],
    };
  },
  methods: {
    // 点击radio
    clickRadio(val) {
      // console.log(val,46);
      this.$emit("changeRadioVal", val);
      //   this.$emit("requestCommonFn");
    },
  },
  created() {
    // 节点类型 4作业 5问卷
    if (this.is_show == 1) {
      PointerNumber({ type: 4 }).then((res) => {
        for (let key in res.data) {
          this.countArr.push(res.data[key]);
        }
        //   console.log(this.countArr,'54');
      });
    } else if (this.is_show == 2)  {
      PointerNumber({ type: 5 }).then((res) => {
        for (let key in res.data) {
          this.countArr.push(res.data[key]);
        }
        //   console.log(this.countArr,'54');
      });
    }
  },
};
</script>
 
<style lang = "less" scoped>
.my_radio_group {
}
</style>